import React from 'react'

const QRCodeIcon = ({
  color = '#333',
  style = {},
}: {
  color?: string
  style?: React.CSSProperties
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    style={style}
    stroke={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 4.5V7.5H4.5V4.5H7.5ZM9 3H3V9H9V3ZM7.5 12.5V15.5H4.5V12.5H7.5ZM9 11H3V17H9V11ZM15.5 4.5V7.5H12.5V4.5H15.5ZM17 3H11V9H17V3ZM11 11H12.5V12.5H11V11ZM12.5 12.5H14V14H12.5V12.5ZM14 11H15.5V12.5H14V11ZM11 14H12.5V15.5H11V14ZM12.5 15.5H14V17H12.5V15.5ZM14 14H15.5V15.5H14V14ZM15.5 12.5H17V14H15.5V12.5ZM15.5 15.5H17V17H15.5V15.5ZM20 5H18V2H15V0H20V5ZM20 20V15H18V18H15V20H20ZM0 20H5V18H2V15H0V20ZM0 0V5H2V2H5V0H0Z"
      fill="#263238"
    />
  </svg>
)

export default QRCodeIcon
